module.exports = __webpack_public_path__ + "img/bagi.0874fc37.png";